import {
    ComponentsOverrides,
    ComponentsProps,
    ComponentsVariants,
    Theme,
    linearProgressClasses,
    mobileStepperClasses,
} from '@mui/material';

export const MuiMobileStepper: {
    defaultProps?: ComponentsProps['MuiMobileStepper'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiMobileStepper'];
    variants?: ComponentsVariants['MuiMobileStepper'];
} = {
    defaultProps: {
        backButton: null,
        nextButton: null,
        variant: 'progress',
    },
    styleOverrides: {
        root: (props) => [
            {
                backgroundColor: 'transparent',
                padding: props.theme.spacing(props.theme.tokens.spacing.md, props.theme.tokens.spacing.none),
                [`& .${mobileStepperClasses.progress}`]: {
                    width: '100%',
                },
                [`& .${linearProgressClasses.barColorPrimary}`]: {
                    backgroundColor: props.theme.palette.info.main,
                },
                [`& .${linearProgressClasses.colorPrimary}`]: {
                    backgroundColor: props.theme.palette.info.light,
                },
            },
        ],
    },
    variants: [],
};
